<script setup lang="ts">
import Avatar from '@/modules/shared/components/AvatarComponent.vue';
import { ArrowRightStartOnRectangleIcon } from '@heroicons/vue/16/solid';
import { useMainStore } from '@/modules/shared/stores/mainStore';
import { useRouter } from 'vue-router';
import useDemoApi from '@/modules/shared/composable/useDemoApi';
import { ref } from 'vue';

const { getMe } = useDemoApi();
const router = useRouter();
const mainStore = useMainStore();
const user = ref();
user.value = getMe();

const props = defineProps({
    hintText: {
        type: String,
        default: ''
    },
    supportingText: {
        type: String,
        default: ''
    }
});

const logout = async (): Promise<void> => {
    localStorage.removeItem('userToken');
    router.push({ name: 'login' });
};
</script>

<template>
    <section class="w-full p-3 border-t border-gray-200">
        <div class="flex items-center justify-between rounded-md hover:bg-gray-950/5 cursor-pointer antialiased transition ease-linear duration-75" @click="logout">
            <div class="flex items-center gap-2 px-2 py-1 truncate">
                <Avatar type="initials" size="sm" :avatarName="user.email" />
                <div class="w-full flex flex-col font-inter truncate">
                    <span class="font-medium leading-5 text-xs text-gray-700 truncate">{{ props.hintText }}</span>
                    <span v-if="props.supportingText" class="font-medium text-xs text-gray-500 truncate">{{ props.supportingText }}</span>
                </div>
            </div>
            <div class="w-4 h-4" :class="mainStore.isMobileOrTablet ? 'mr-3' : 'mr-2'">
                <ArrowRightStartOnRectangleIcon class="w-4 h-4 text-gray-500" />
            </div>
        </div>
    </section>
</template>
